// Remove this file with OPTIMIZE_TRANSLATION_IMPORT FF
import { translations } from './translations';

export function getLanguageLocale(requestedLocale: string): keyof typeof translations {
  if (!isAvailableLocale(requestedLocale)) {
    // todo...
    console.warn(`Requested locale ${requestedLocale as string} is not available, falling back to nl-NL`);
    return 'nl-NL';
  }
  return requestedLocale;
}

function isAvailableLocale(locale: string): locale is keyof typeof translations {
  return Object.keys(translations).includes(locale);
}
